module.exports = __webpack_public_path__ + "01_short_yellow.229568f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_short_yellow.png
// module id = 542+
// module chunks = 0